/**
 * This is async version of noop.
 *
 * @signature -> Promise<undefined>
 */
var noopAsync = function noopAsync() {
  return Promise.resolve(undefined);
};
module.exports = noopAsync;